import axios from "axios";
import qs from "qs";

//获取回收站

export interface DeleteItemProps {
    fileName: string;
    expireTime: string;
    fileSize: string;
    updateTime: string;
    id: string;
    fileType: string;
    viewUrl: string;
}
export function getDeleteFileList() {
    return axios
        .get<SuccessData<DeleteItemProps[]>>(
            "/teacher/chapter/getDeleteFileList"
        )
        .then(res => res.data.data);
}

//回收站删除
export interface DeleteProps {
    id: string;
}
export function deleteDeleteFile(data: DeleteProps) {
    return axios.post("/teacher/chapter/deleteDeleteFile", qs.stringify(data));
}
